module.exports = __webpack_public_path__ + "static/media/bakri-steps-of-use-poster.35b73e10.jpg";